/**
 * Static news source catalog with feed URLs and topics.
 */
export const sources = [
  {
    id: "@penaestrada",
    alignments: {},
    name: "Pé na Estrada",
    url: "https://www.penaestrada.blog.br",
    image: "https://www.penaestrada.blog.br/wp-content/uploads/2019/02/cropped-icon-192x192.png",
    feeds: [{ topic: "travel", rss: "https://www.penaestrada.blog.br/feed/" }],
  },
  {
    id: "@melhoresdestinos",
    alignments: {},
    name: "Melhores Destinos",
    url: "https://www.melhoresdestinos.com.br",
    image: "https://www.melhoresdestinos.com.br/apple-touch-icon.png",
    feeds: [{ topic: "travel", rss: "https://www.melhoresdestinos.com.br/feed/" }],
  },
  {
    id: "@passageirodeprimeira",
    alignments: {},
    name: "Passageiro de Primeira",
    url: "https://passageirodeprimeira.com",
    image: "https://passageirodeprimeira.com/wp-content/uploads/2026/04/cropped-favicon-pp-2026-favicon-pp-2026-cropped-favicon-pp-2026-favicon-pp-2026-2-192x192.png",
    feeds: [{ topic: "travel", rss: "https://passageirodeprimeira.com/feed/" }],
  },
  {
    id: "@spacetoday",
    alignments: {},
    name: "Space Today",
    url: "https://spacetoday.com.br",
    image: "https://spacetoday.com.br/wp-content/uploads/2021/03/cropped-marca-dagua-spacetoday-192x192.png",
    feeds: [{ topic: "science", rss: "https://spacetoday.com.br/feed/" }],
  },
  {
    id: "@manualdousuario",
    alignments: {},
    name: "Manual do Usuário",
    url: "https://manualdousuario.net",
    image: "https://manualdousuario.net/apple-touch-icon.png?v=20260630",
    feeds: [{ topic: "technology", rss: "https://manualdousuario.net/feed/" }],
  },
  {
    id: "@macmagazine",
    alignments: {},
    name: "MacMagazine",
    url: "https://macmagazine.com.br",
    image: "https://macmagazine.com.br/wp-content/uploads/2022/11/cropped-mm_favicon-192x192.png",
    feeds: [{ topic: "technology", rss: "https://macmagazine.com.br/feed/" }],
  },
  {
    id: "@adrenaline",
    alignments: {},
    name: "Adrenaline",
    url: "https://www.adrenaline.com.br",
    image: "https://www.adrenaline.com.br/wp-content/uploads/2023/04/cropped-favicon-192x192.jpg",
    feeds: [{ topic: "technology", rss: "https://www.adrenaline.com.br/feed/" }],
  },
  {
    id: "@uolnoticias",
    alignments: {
      headlines: { alignment: "neutral", status: "confirmed" },
      economy: { alignment: "neutral", status: "confirmed" },
    },
    name: "UOL",
    url: "https://www.uol.com.br",
    image: "https://conteudo.imguol.com.br/c/home/layout/camaleao/app/512x512.png",
    feeds: [
      { topic: "headlines", rss: "https://rss.uol.com.br/feed/noticias.xml" },
      { topic: "economy", rss: "https://rss.uol.com.br/feed/economia.xml" },
    ],
  },
  {
    id: "@cnnbrasil",
    alignments: {},
    name: "CNN Brasil",
    url: "https://www.cnnbrasil.com.br",
    image: "https://www.cnnbrasil.com.br/apple-touch-icon.png",
    feeds: [{ topic: "headlines", rss: "https://www.cnnbrasil.com.br/feed/" }],
  },
  {
    id: "@gamevicio",
    alignments: {},
    name: "GameVício",
    url: "https://www.gamevicio.com",
    image: "https://www.gamevicio.com/wp-content/uploads/2025/05/favicon-big-2.webp",
    feeds: [{ topic: "gaming", rss: "https://www.gamevicio.com/feed" }],
  },
  {
    id: "@meups",
    alignments: {},
    name: "MeuPlayStation",
    url: "https://meups.com.br",
    image: "https://meups.com.br/wp-content/uploads/2024/08/512.png",
    feeds: [{ topic: "gaming", rss: "https://meups.com.br/feed/" }],
  },
  {
    id: "@brasildefato",
    alignments: {
      headlines: { alignment: "left", status: "confirmed" },
    },
    name: "Brasil de Fato",
    url: "https://www.brasildefato.com.br",
    image: "https://www.brasildefato.com.br/wp-content/uploads/2024/09/cropped-favicon-192x192.webp",
    feeds: [{ topic: "headlines", rss: "https://www.brasildefato.com.br/feed/" }],
  },
  {
    id: "@gazetadopovo",
    alignments: {
      headlines: { alignment: "right", status: "confirmed" },
      politic: { alignment: "right", status: "confirmed" },
      economy: { alignment: "right", status: "confirmed" },
    },
    name: "Gazeta do Povo",
    url: "https://www.gazetadopovo.com.br",
    image: "https://gdp-prd-data.s3.amazonaws.com/assembler-next-home/_next/static/media/favicon.8cf49dc1.ico",
    feeds: [
      { topic: "headlines", rss: "https://www.gazetadopovo.com.br/feed/rss/ultimas-noticias.xml" },
      { topic: "politic", rss: "https://www.gazetadopovo.com.br/feed/rss/republica.xml" },
      { topic: "economy", rss: "https://www.gazetadopovo.com.br/feed/rss/economia.xml" },
    ],
  },
  {
    id: "@bbcbrasil",
    alignments: {
      headlines: { alignment: "neutral", status: "confirmed" },
    },
    name: "BBC Brasil",
    url: "https://www.bbc.com/portuguese",
    image: "https://static.files.bbci.co.uk/ws/simorgh-assets/public/portuguese/images/icons/icon-192x192.png",
    feeds: [{ topic: "headlines", rss: "https://www.bbc.co.uk/portuguese/index.xml" }],
  },
  {
    id: "@g1",
    alignments: {},
    name: "G1",
    url: "https://g1.globo.com",
    image: "https://s2-g1.glbimg.com/9yYCBhtSsy23W0pNwYgEil7i_eM=/144x0/http://i.s3.glbimg.com/v1/AUTH_afd7a7aa13da4265ba6d93a18f8aa19e/pox/g1.png",
    feeds: [
      { topic: "headlines", rss: "https://g1.globo.com/rss/g1/" },
      { topic: "world", rss: "https://g1.globo.com/rss/g1/mundo" },
      { topic: "politic", rss: "https://g1.globo.com/rss/g1/politica" },
      { topic: "economy", rss: "https://g1.globo.com/rss/g1/economia" },
      { topic: "technology", rss: "https://g1.globo.com/rss/g1/tecnologia" },
    ],
  },
  {
    id: "@folha",
    alignments: {
      headlines: { alignment: "right", status: "confirmed" },
      brazil: { alignment: "right", status: "confirmed" },
      world: { alignment: "right", status: "confirmed" },
      politic: { alignment: "right", status: "confirmed" },
      economy: { alignment: "right", status: "confirmed" },
    },
    name: "Folha de S.Paulo",
    url: "https://www1.folha.uol.com.br",
    image: "https://f.i.uol.com.br/hunting/folha/1/common/icons/favicon-192.png",
    feeds: [
      { topic: "headlines", rss: "https://feeds.folha.uol.com.br/emcimadahora/rss091.xml" },
      { topic: "brazil", rss: "https://feeds.folha.uol.com.br/cotidiano/rss091.xml" },
      { topic: "science", rss: "https://feeds.folha.uol.com.br/ciencia/rss091.xml" },
      { topic: "entertainment", rss: "https://feeds.folha.uol.com.br/ilustrada/rss091.xml" },
      { topic: "world", rss: "https://feeds.folha.uol.com.br/mundo/rss091.xml" },
      { topic: "politic", rss: "https://feeds.folha.uol.com.br/poder/rss091.xml" },
      { topic: "economy", rss: "https://feeds.folha.uol.com.br/mercado/rss091.xml" },
      { topic: "technology", rss: "https://feeds.folha.uol.com.br/tec/rss091.xml" },
      { topic: "health", rss: "https://feeds.folha.uol.com.br/equilibrioesaude/rss091.xml" },
    ],
  },
  {
    id: "@agenciabrasil",
    useFeedImages: false,
    alignments: {
      headlines: { alignment: "neutral", status: "confirmed" },
      brazil: { alignment: "neutral", status: "confirmed" },
      world: { alignment: "neutral", status: "confirmed" },
      politic: { alignment: "neutral", status: "confirmed" },
      economy: { alignment: "neutral", status: "confirmed" },
    },
    name: "Agência Brasil",
    url: "https://agenciabrasil.ebc.com.br",
    image: "https://agenciabrasil.ebc.com.br/sites/default/themes/agenciabrasil_v3/favicon.ico",
    feeds: [
      { topic: "headlines", rss: "https://agenciabrasil.ebc.com.br/rss/ultimasnoticias/feed.xml" },
      { topic: "brazil", rss: "https://agenciabrasil.ebc.com.br/rss/geral/feed.xml" },
      { topic: "world", rss: "https://agenciabrasil.ebc.com.br/rss/internacional/feed.xml" },
      { topic: "politic", rss: "https://agenciabrasil.ebc.com.br/rss/politica/feed.xml" },
      { topic: "economy", rss: "https://agenciabrasil.ebc.com.br/rss/economia/feed.xml" },
      { topic: "health", rss: "https://agenciabrasil.ebc.com.br/rss/saude/feed.xml" },
    ],
  },
  {
    id: "@infomoney",
    alignments: {},
    name: "InfoMoney",
    url: "https://www.infomoney.com.br",
    image: "https://www.infomoney.com.br/wp-content/uploads/2019/10/IM-Favicon.png?fit=128%2C128&quality=70&strip=all",
    feeds: [{ topic: "headlines", rss: "https://www.infomoney.com.br/feed/" }],
  },
  {
    id: "@cartacapital",
    alignments: {
      headlines: { alignment: "left", status: "confirmed" },
    },
    name: "CartaCapital",
    url: "https://www.cartacapital.com.br",
    image: "https://www.cartacapital.com.br/wp-content/uploads/2020/08/cropped-CARTA512-96x96.jpg",
    feeds: [
      { topic: "headlines", rss: "https://www.cartacapital.com.br/feed/" },
    ],
  },
  {
    id: "@poder360",
    alignments: {
      headlines: { alignment: "neutral", status: "confirmed" },
    },
    name: "Poder360",
    url: "https://www.poder360.com.br",
    image: "https://www.poder360.com.br/wp-content/themes/poder/assets/img/ico/android-icon-192x192.png",
    feeds: [{ topic: "headlines", rss: "https://www.poder360.com.br/feed/" }],
  },
  {
    id: "@jovempan",
    alignments: {
      headlines: { alignment: "right", status: "confirmed" },
    },
    name: "Jovem Pan",
    url: "https://jovempan.com.br",
    image: "https://jovempan.com.br/wp-content/uploads/sites/2/2026/06/cropped-favicon.png?w=192",
    feeds: [{ topic: "headlines", rss: "https://jovempan.com.br/feed" }],
  },
  {
    id: "@nintendoblast",
    alignments: {},
    name: "Nintendo Blast",
    url: "https://www.nintendoblast.com.br",
    image: "https://www.nintendoblast.com.br/favicon.ico",
    feeds: [{ topic: "gaming", rss: "https://www.nintendoblast.com.br/feeds/posts/default?alt=rss" }],
  },
  {
    id: "@veja",
    alignments: {
      headlines: { alignment: "right", status: "confirmed" },
      brazil: { alignment: "right", status: "confirmed" },
      world: { alignment: "right", status: "confirmed" },
      politic: { alignment: "right", status: "confirmed" },
      economy: { alignment: "right", status: "confirmed" },
    },
    name: "VEJA",
    url: "https://veja.abril.com.br",
    image: "https://veja.abril.com.br/wp-content/uploads/2023/04/cropped-VEJA.png?quality=70&w=512",
    feeds: [
      { topic: "headlines", rss: "https://veja.abril.com.br/ultimas-noticias/rss" },
      { topic: "brazil", rss: "https://veja.abril.com.br/brasil/rss" },
      { topic: "world", rss: "https://veja.abril.com.br/mundo/rss" },
      { topic: "politic", rss: "https://veja.abril.com.br/politica/rss" },
      { topic: "technology", rss: "https://veja.abril.com.br/tecnologia/rss" },
      { topic: "economy", rss: "https://veja.abril.com.br/economia/rss" },
      { topic: "health", rss: "https://veja.abril.com.br/saude/rss" },
      { topic: "science", rss: "https://veja.abril.com.br/ciencia/rss" },
      { topic: "entertainment", rss: "https://veja.abril.com.br/cultura/rss" },
    ],
  },
  {
    id: "@capricho",
    alignments: {},
    name: "CAPRICHO",
    url: "https://capricho.abril.com.br",
    image: "https://capricho.abril.com.br/wp-content/uploads/2023/08/favicon-capricho.png?quality=85&w=269",
    feeds: [{ topic: "entertainment", rss: "https://capricho.abril.com.br/entretenimento/feed/" }],
  },
  {
    id: "@vejasaude",
    alignments: {},
    name: "VEJA Saúde",
    url: "https://saude.abril.com.br",
    image: "https://saude.abril.com.br/wp-content/uploads/2023/04/cropped-VEJA-SAUDE.png?quality=85&w=512",
    feeds: [{ topic: "health", rss: "https://saude.abril.com.br/feed/" }],
  },
  {
    id: "@pesquisafapesp",
    alignments: {},
    name: "Pesquisa FAPESP",
    url: "https://revistapesquisa.fapesp.br",
    image: "https://revistapesquisa.fapesp.br/wp-content/uploads/2026/09/cropped-favicon-revista-pesquisa-fapesp-512-PF-192x192.png",
    feeds: [{ topic: "science", rss: "https://revistapesquisa.fapesp.br/feed/" }],
  },
  {
    id: "@superinteressante",
    alignments: {},
    name: "Superinteressante",
    url: "https://super.abril.com.br",
    image: "https://super.abril.com.br/wp-content/uploads/2023/04/cropped-Super-reduzido.png?quality=70&w=512",
    feeds: [{ topic: "science", rss: "https://super.abril.com.br/ciencia/feed/" }],
  },
  {
    id: "@gizmodo",
    alignments: {},
    name: "Gizmodo",
    url: "https://www.gizmodo.com.br",
    image: "https://www.gizmodo.com.br/apple-touch-icon.png?v1",
    feeds: [{ topic: "science", rss: "https://www.gizmodo.com.br/ciencia/feed" }],
  },
  {
    id: "@jornaldausp",
    alignments: {},
    name: "Jornal da USP",
    url: "https://jornal.usp.br",
    image: "https://jornal.usp.br/wp-content/uploads/2019/10/jornal_da_usp_home_logo_usp_cinza.jpg",
    feeds: [{ topic: "science", rss: "https://jornal.usp.br/editorias/ciencias/feed/" }],
  },
  {
    id: "@cinepop",
    alignments: {},
    name: "CinePOP",
    url: "https://cinepop.com.br",
    image: "https://cinepop.com.br/wp-content/uploads/2026/08/cropped-CinePOPnovo-4-192x192.png",
    feeds: [{ topic: "cinema", rss: "https://cinepop.com.br/feed/" }],
  },
  {
    id: "@cinemagem",
    alignments: {},
    name: "Cinemagem",
    url: "https://cinemagem.com.br",
    image: "https://cinemagem.com.br/wp-content/uploads/2022/12/perfil.png",
    feeds: [{ topic: "cinema", rss: "https://cinemagem.com.br/editoria/cinema/feed/" }],
  },
  {
    id: "@cinebuzz",
    alignments: {},
    name: "CineBuzz",
    url: "https://cinebuzz.com.br",
    image: "https://cinebuzz.com.br/wp-content/uploads/2025/07/cinebuzz_logo-21-1.png",
    feeds: [{ topic: "cinema", rss: "https://cinebuzz.com.br/feed/" }],
  },
];
